<template>
  <div class="home contenido">
    <div class="container">
        <HelloWorld 
            msg="Creamos un mejor presente y futuro"
            idea="Un compromiso que ofrece tranquilidad y certeza a los planes de personas, familias y empresas."
            :imagen="imagen"
         />
         <Titulo titulo="¿Quiénes somos?" />
         <div class="espacio mt-5"></div>
         <Fototextosombra titulo="Conocimiento para que tomes decisiones" texto="Desde 2004 damos estabilidad, respuesta y acompañamiento a nuestros clientes y amigos, pues algunos de ellos están con nosotros desde el inicio.<br /><br />Generamos certeza en tu crecimiento, mediante el cumplimiento de nuestras responsabilidades y anticipación para que logres tus metas o estés cubierto ante cualquier circunstancia." :imagen="imagen2" pos="fotoderecha" />
         <Fototextosombra texto="Creemos que solo a través de la comprensión de cada producto, sus detalles y tus necesidades tienes argumentos para que tomes esta decisión de vida.<br /><br /> Te acompañamos para brindarte un amplio panorama del riesgo y de las diferentes opciones que puedes elegir, pues sabemos que harás solo lo mejor para ti y los tuyos por que estarás preparado." :imagen="imagen3" pos="fotoizquierda" />
    </div>
    <div class="gris py-5 mt-5">
        <div class="container py-5">
            <div class="row m-0">
                <div class="col-lg-6">
                    <h3>Estamos certificados,<br />estamos preparados.</h3>
                    <div class="texto p-3">
                        Desde el 2012, <u>The National Alliance</u>, organismo reconocido en Norte América y el mundo, nos avala para brindarte lo mejor de la <strong>Administración de Riesgos</strong> con acciones fundamentales que garanticen la mejor toma de decisiones y un crecimiento sostenible, beneficio que buscan los grandes y los que están en camino de serlo.
                    </div>
                </div>
                <div class="col-lg-6 pt-0 pt-lg-4">
                    <div class="row m-0">
                        <div class="col-5 col-lg-5 mt-4 text-right">
                            <img src="@/assets/images/logo-CRM.svg" class="img-crm" data-aos="fade-up" data-aos-duration="1000" />
                        </div>
                        <div class="col-7 col-lg-7">
                            <div class="crm-titulo mb-2 mt-4 mt-lg-5">
                                THE NATIONAL ALLIANCE FOR INSURANCE EDUCATION & RESEARCH
                            </div>
                            <div class="crm-subtitulo">
                                Certified Risk Management International
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="m5 py-5">
             <Titulo titulo="Nuestros valores" />
             <div class="row mx-0 my-3">
                <div class="col-lg-6">
                    <CuadroTexto titulo="Conocimiento" texto="Una de las claves nuestro trabajo es entender, tanto la totalidad de los seguros y las letras chicas de las compañías que los ofrecen, como las eventualidades y posibilidades de personas y empresas. El resultado: vínculos fuertes, confianza y autoridad con que nos reconocen nuestros clientes." />
                </div>
                <div class="col-lg-6">
                    <CuadroTexto titulo="Empatía" texto="Participamos objetiva y profundamente en los planes de clientes, amigos y proveedores. Nos vemos como un equipo que se involucra en cada trato, siempre humanos, cálidos y participando activamente en cada proyecto." />
                </div>
                <div class="col-lg-6">
                    <CuadroTexto titulo="Eficacia" texto="En <strong>RMZ Asesores</strong> creemos que todo aquello que esté destinado a hacerse o a ser, debe cumplirse. De ahí que nuestra atención logre lo mejor para nuestros clientes en las condiciones que ellos requieren." />
                </div>
                <div class="col-lg-6">
                    <CuadroTexto titulo="Integridad" texto="En un tipo de servicio como este, no podemos actuar de otra forma. El tiempo ha probado nuestra honestidad y compromiso, gracias al orden de nuestros procesos, al trato fiable y justo con una trayectoria irreprochable, que establece relaciones a largo plazo." />
                </div>
             </div>
        </div>
    </div>
    <div class="triangulo"></div>
    <div class="contenidoTriangulo">
         <Titulo titulo="<strong>RMZ Asesores</strong> en el tiempo" />
         <div class="row m-0 justify-content-center">
            <div class="col-12 col-lg-10 text-center blanco px-5 pt-5 pb-0 pb-lg-5 m-5">
                <center>
                    <img src="@/assets/images/rmz-historia.png" class="img-fluid d-none d-md-block m-5" data-aos="fade-up" data-aos-duration="1000" />
                    <img src="@/assets/images/rmz-historia-m.png" class="img-fluid d-block d-md-none" data-aos="fade-up" data-aos-duration="1000" />
                </center>
            </div>
         </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Imagen from '@/assets/images/banner-header_00-nosotros.png'
import Imagen2 from '@/assets/images/nosotros_01-conocimiento-para-que-tomes-decisiones.jpg'
import Imagen3 from '@/assets/images/nosotros_02-conocimiento-para-que-tomes-decisiones.jpg'
import Titulo from '@/components/Titulo.vue'
import Fototextosombra from '@/components/Fototextosombra.vue'
import CuadroTexto from '@/components/CuadroTexto.vue'
export default {
  name: 'Nosotros',
  data() {
      return {
          imagen: Imagen,
          imagen2: Imagen2,
          imagen3: Imagen3,
      }
  },
  components: {
    HelloWorld,
    Titulo,
    Fototextosombra,
    CuadroTexto,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      muestraFooter: function(){
          this.$store.commit('muestraFooter');
      }
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.muestraFooter();
      this.$store.commit('mideMenos', false);
      this.$store.commit('mideMas', false);
      this.$store.commit('estira', false);
  }
}
</script>
<style scoped>
.blanco {
    background: #FFF;
}
.contenido {
    min-height: 500px;
}
.gris {
    background: #F2F2F2;
    border-bottom: 8px solid #000;
    margin-top: 180px !important;
}
.triangulo {
    width: 100%;
    height: 100px;
    clip-path: polygon(50% 0, 0 100%, 100% 100%);
    background: #E6E7F4;
    margin-top: 150px;
}
.contenidoTriangulo {
    background: #E6E7F4;
    padding: 1px 0 150px 0;
}
h3 {
    font-size: 26px;
    font-weight: 700;
}
.texto {

}
.crm-titulo {
    font-weight: 700;
    font-size: 14px;
}
.crm-subtitulo {
    font-weight: 700;
    font-size: 18px;
}
.img-crm {
    width: 125px;
}
@media only screen and (max-width: 1199px){
    .crm-titulo {
        font-weight: 700;
        font-size: 14px;
    }
    .crm-subtitulo {
        font-weight: 700;
        font-size: 17px;
    }
    .img-crm {
    }
    .triangulo {
        height: 50px;
    }
}
</style>
